import styled from "styled-components";


export const AvailabilityPageContainer = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    font-family: Outfit;
`

export const CARPContainer = styled.div`
    padding: 20px;
`

export const CARPInternalContainer = styled.div`
    display: grid;
    grid-template-columns: 1fr 3fr 3fr 2fr;
    border-bottom: 1px solid #000;
    padding: 4px 0;
    ${props => props?.isFirstRow && 'border-top: 1px solid #000;'};
`